angular.module('iqxCore').controller('ProvTimesheetsCtrl', function ($scope, $routeParams, $location, $http, $window, FormSvc, ApplicationSvc, ApiSvc, $timeout, SweetAlert, TerminologySvc, BehaviourSvc) {
  $scope.showTSCreateBtn = true
  $scope.timesheetAuth = $routeParams.role == 'auth'
  $scope.timesheetSelected = {}
  $scope.state = {
    imageRequired: $scope.userHasRight('TSMUSTUPLOADIMAGE'),
    imageAllowed: $scope.userHasRight('TSCANUPLOADIMAGE') || $scope.userHasRight('TSMUSTUPLOADIMAGE')
  }
  $scope.theRecord = {}

  $scope.getValues = function () {
    if (ApplicationSvc.currentUser.UserClass === 'CANDIDATE') {
      $scope.theRecord.startDateFilter = moment('1990-01-01').toDate()
      $scope.theRecord.endDateFilter = moment().add(1, 'year').toDate()
      return Promise.resolve()
    } else {
      return $timeout(function () {}, 200).then(function () {
        if ($scope.params.CLIENTTSDATEFROM && $scope.params.CLIENTTSDATETO) {
          $scope.theRecord.startDateFilter = moment().subtract($scope.params.CLIENTTSDATEFROM, 'days').toDate()
          $scope.theRecord.endDateFilter = moment().add($scope.params.CLIENTTSDATETO, 'days').toDate()
        } else {
          $scope.theRecord.startDateFilter = moment().subtract(1, 'year').toDate()
          $scope.theRecord.endDateFilter = moment().add(1, 'year').toDate()
        }
        return Promise.resolve()
      })
    }
  }

  $scope.getFiltered = function () {
    FormSvc.setOptions($scope, {
      fetchAPI:
        'callresult/netprovtimesheets' +
        ($scope.timesheetAuth ? '?pForAuthorise=1&' : '?') +
        ($scope.theRecord.startDateFilter ? 'pStartDate=' + moment($scope.theRecord.startDateFilter).format('YYYY-MM-DD') + '&' : '') +
        ($scope.theRecord.endDateFilter ? 'pEndDate=' + moment($scope.theRecord.endDateFilter).format('YYYY-MM-DD') + '&' : '') +
        ($scope.theRecord.Position ? 'pPosition=' + $scope.theRecord.Position.replace('%', '|%').replace('_', '_%') + '&' : '') +
        ($scope.theRecord.theirRef ? 'ptheirRef=' + $scope.theRecord.theirRef.replace('%', '|%').replace('_', '_%') + '&' : ''),
      dateFields: ['weekenddate'],
      booleanFields: ['hasScannedImage', 'awaitsAuthorisation', 'canApprove', 'IsSignRequested', 'IsSigned'],
      multiRow: true,
      sliceSize: 10,
      autoEdit: true,
      fetchWithPersonID: true
    })
    return $scope.fetch().then(function () {
      // Store TSSSHOWPOSITION here so that position column can be switchable for clients
      $scope.showPosition = ApplicationSvc.params.behaviour.TSSSHOWPOSITION
      $scope.theRecords.forEach((timesheet) => {
        timesheet.weekstartdate = moment(timesheet.weekenddate).subtract(6, 'd').toDate()
      })
    })
  }

  $scope.authoriseAll = function ($event) {
    SweetAlert.swal({
      title: 'Are you sure?',
      html: 'This will authorise all of the timesheets that are currently displayed.',
      type: 'info',
      confirmButtonText: 'Yes, authorise all timesheets',
      cancelButtonText: 'Cancel',
      showCancelButton: true,
      allowOutsideClick: false,
      allowEscapeKey: true
    }).then(function (result) {
      if (result.dismiss) {
        return
      } else {
        $scope.theRecords.forEach(function (ts) {
          if (!ts.authorised) {
            return $scope.authorise($event, ts)
          }
        })
      }
    })
  }

  $scope.doAuthorise = function (ts) {
    if (ts.timesheettype == 'S') {
      return $scope.exec('service/ProvTSComplete', { ID: ts.tempprovtimesheetid })
    } else {
      return $scope.exec('service/ProvNonShiftTSComplete', { ID: ts.tempprovtimesheetid })
    }
  }

  $scope.authorise = function ($event, ts) {
    $event.stopPropagation() // Prevent row click drill down
    $scope.formError = ''
    $scope
      .doAuthorise(ts)
      .then(function () {
        return $scope.exec('call/NetAudit', { pActionType: 'TIMESHEETAUTHORISE', pDescription: 'Number ' + ts.serialnumber, pRecordID: ts.serialnumber })
      })
      .then(function () {
        ts.authorised = true
      })
      .then(function () {
        if ($scope.userHasRight('APPROVETIMESHEETS') && ts.canApprove && $scope.userHasRight('AUTOAPPROVETIMESHEET')) {
          // Approve immediately
          return $scope.exec('call/NetTimesheetIDFromSerialNumber', { pSerialNumber: ts.serialnumber })
        }
      })
      .then(function (res) {
        if (res) {
          // NetTimesheetIDFromSerialNumber was called and returned successfully
          var tsid = res.IQXResult.IQXSuccess.attrs.id // id will be empty if could not uniquely match the serialnumber
          if (tsid) {
            return $scope.exec('call/NetTimesheetApprove', { pTempTimesheetList: tsid })
          }
        }
      })
  }

  $scope.showImage = function ($event, ts) {
    $event.stopPropagation() // Prevent row click drill down
    $scope.formError = ''
    $http
      .get('/api/document/doxi', { params: { Type: 'TIMESHEET', ProvTimesheetID: ts.tempprovtimesheetid } })
      .then(function (res) {
        $window.open('/api/document/download?doxi=' + res.data, '_blank')
      })
      .catch(function (err) {
        $scope.formError = ApiSvc.ExtractError(err)
      })
  }

  $scope.expandTimesheet = function (ts) {
    if (!ts.authorised) {
      // provtimesheet no longer exists once authorised
      $location.url('/provtimesheet?id=' + ts.tempprovtimesheetid)
    }
  }

  $scope.downloadImage = function (timesheet) {
    timesheet.downloadError = ''
    $http
      .get('/api/document/doxi', { params: { Type: 'TIMESHEET', ProvTimesheetID: timesheet.tempprovtimesheetid } })
      .then(function (res) {
        $window.open('/api/document/download?doxi=' + res.data, '_blank')
      })
      .catch(function (err) {
        timesheet.downloadError = ApiSvc.ExtractError(err)
      })
  }

  $scope.createTS = function () {
    return ApiSvc.exec($scope, 'call/NetCandidateCreateProvTimesheets', {
      pPersonID: ApplicationSvc.currentUser.personID,
      pWeekCount: $scope.numberOfWeeksToCheckForTimesheets || 5
    })
      .then(function (x) {
        sessionStorage.setItem('TSCREATE', 'y')
        $scope.showTSCreateBtn = false
        var countdown = 300 // in seconds ...

        function tick() {
          if (countdown > 0) {
            countdown = countdown - 1
            setTimeout(tick, 1000)
          } else {
            $scope.showTSCreateBtn = true
            $scope.$apply()
          }
        }
        tick()
      })
      .then($scope.getFiltered)
      .catch(function (x) {})
  }

  $scope.getDivisionTimesheetSigningRightsAndTerms = function () {
    return ApiSvc.fetch($scope, {
      fetchAPI: 'callresult/NetCandidateRegDetails?pPersonID=' + (ApplicationSvc.currentUser.personID || ''),
      fetchTarget: 'RegDets',
      multiRow: false,
      booleanFields: ['DepartmentPerm', 'DepartmentTemp']
    })
      .then(function () {
        /* Ensure we have these stored. */
        TerminologySvc.getTerminology()
          .then(function (value) {
            ApplicationSvc.currentUser.registrationDetails.DivisionID = $scope.RegDets.DivisionID
            ApplicationSvc.currentUser.registrationDetails.DepartmentID = $scope.RegDets.DepartmentID
            $scope.numberOfWeeksToCheckForTimesheets = ApplicationSvc.params.behaviour.TSSNUMOFWEEKSCHECKFORTIMESHEET
            $scope.useWeekStartDateOnTS = ApplicationSvc.params.behaviour.TSSWEEKSTART
            $scope.showNeedsSignature = ApplicationSvc.params.behaviour.TSSNEEDSSIGNATURE
            $scope.terms = value
            $scope.showPosition = ApplicationSvc.params.behaviour.TSSSHOWPOSITION
            $scope.showVacancy = ApplicationSvc.params.behaviour.TSSSHOWVACANCY
          })
          .catch(function (error) {
            console.error(error)
          })
      })
      .catch(function (e) {
        console.error(e)
      })
  }

  $scope.showTSKey = function () {
    return FormSvc.modalInfo($scope, 'TSKEY', { choices: [{ desc: 'Close', type: 'primary', code: '' }] }, 'md')
  }

  $scope.getValues().then(function () {
    if (ApplicationSvc.currentUser.UserClass === 'CANDIDATE' && $scope.isSwitchedOn('FETCHCANDTSSET') && BehaviourSvc.isSwitchedOn('TSSDISABLE') !== true) {
      $scope.getDivisionTimesheetSigningRightsAndTerms().then(function () {
        if ($scope.isSwitchedOn('TSCREATE')) {
          return $scope.createTS()
        } else {
          $scope.getFiltered()
        }
      })
    } else {
      TerminologySvc.getTerminology().then(function (value) {
        $scope.terms = value
      })
      $scope.getFiltered()
    }
  })
})
